import { FileFormat } from "./transactionDownloadHelpers";

export default [
  { displayName: "Quickbooks (QBO)", value: "qbo" },
  { displayName: "Quicken (QFX)", value: "qfx" },
] satisfies { displayName: string; value: FileFormat }[];
